module.exports = __webpack_public_path__ + "img/Peter.d6b4f007.png";